import { fetchIStatus } from '@/shared/fetchIStatus';
import { IPet } from '@/shared/interfaces';

export const deletePet = async (petData: IPet) => {
    return await fetchIStatus<void, void>(`/api/pets/${petData.Id}`, 'DELETE');
};
